<template>
  <div class="w-16 dark:text-dark.textOnBkg">
    <MazSelect
      v-model="currentLang"
      size="mini"
      :options="options"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentLang: this.$i18n.locale, // Initialize with the current locale
      options: [
        { value: 'en', label: 'EN' },
        { value: 'es', label: 'ES' },
        { value: 'fr', label: 'FR' },
        { value: 'de', label: 'DE' },
        { value: 'ro', label: 'RO' },
        { value: 'ru', label: 'RU' },
        { value: 'nl', label: 'NL' }
      ]
    }
  },
  watch: {
    currentLang(newLang) {
      if (newLang === this.$i18n.locale) return
      this.changeLanguage(newLang)
    }
  },
  methods: {
    changeLanguage(newLang) {
      console.log("Changing language to", newLang)
      this.$i18n.locale = this.currentLang
      document.cookie = `language=${this.currentLang}; path=/`
      location.reload()
    }
  },
  created() {
    // Set the initial language from cookies if available
    const lang = document.cookie.replace(/(?:(?:^|.*;\s*)language\s*=\s*([^;]*).*$)|^.*$/, "$1") || 'en'
    this.currentLang = lang
    this.$i18n.locale = lang
  }
}
</script>
